var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nh-title'),_c('div',{staticStyle:{"display":"flex"}},[_c('div',[_c('nh-menu',{attrs:{"active-selected":"PatientListForManager"}})],1),_c('div',{staticStyle:{"width":"calc(100% - 49px)","padding":"30px"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }